module.exports = __webpack_public_path__ + "static/media/camera_icon_gray.49ddb529.svg";